import { render, staticRenderFns } from "./thematicGroupManagement.vue?vue&type=template&id=adf1fb5c"
import script from "./thematicGroupManagement.vue?vue&type=script&lang=js"
export * from "./thematicGroupManagement.vue?vue&type=script&lang=js"
import style0 from "./thematicGroupManagement.vue?vue&type=style&index=0&id=adf1fb5c&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports